module.exports = __webpack_public_path__ + "static/video-poster-2-e6d151deb36336b7a72af22e07357ea8.jpg";